import type { ReactiveVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

type Banners = {
  bannersHeight: number;
};

const INITIAL_STATE: Banners = {
  bannersHeight: 0,
};

const Banners: ReactiveVar<Banners> = makeFSVar(INITIAL_STATE, "useBannersHeightVar");

const resetBanners = () => Banners(INITIAL_STATE);

const setBannersHeight = (bannersHeight: Banners["bannersHeight"]) => {
  const { bannersHeight: unusedBannersHeight, ...rest } = Banners();
  Banners({ ...rest, bannersHeight });
};

/** All the warning banners live in PageHeader component, so setting the height of the banners there so we can know the banners height */
const useBannersHeight = (): Banners => useReactiveVar(Banners);

export { useBannersHeight, setBannersHeight, resetBanners };
